import { useMemo, useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Link as RouterLink } from 'react-router-dom';
import { SidebarCollapseIcon } from 'foundations-assets/icons/components/SidebarCollapseIcon';
import { SidebarExpandIcon } from 'foundations-assets/icons/components/SidebarExpandIcon';
import { MobilePopover } from './MobilePopover';
import { usePortalData } from '../data/usePortalData';
import { useNavigationMenu } from '../hooks/useNavigationMenu';
import I18n from 'I18n';
import { HamburgerMenuIcon } from 'foundations-assets/icons/components/HamburgerMenuIcon';
import { LogoutIcon } from 'foundations-assets/icons/components/LogoutIcon';
import { LOGOUT_PATH } from '../../api/paths';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MenuNode = ({
  node,
  depth,
  setOpen
}) => {
  var _node$children;
  const [localOpen, setLocalOpen] = useState(false);
  const hasChildren = Array.isArray(node.children) && node.children.length;
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "200",
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "space-between",
      paddingInlineStart: depth ? '600' : undefined,
      gap: "400",
      children: [/*#__PURE__*/_jsx("div", {
        children: node.url ? /*#__PURE__*/_jsx(Button, {
          use: "transparent",
          href: node.url,
          onClick: () => setOpen(false),
          children: /*#__PURE__*/_jsx(Text, {
            color: "text-core-default",
            children: node.label
          })
        }) : /*#__PURE__*/_jsx(Text, {
          paddingBlock: "250",
          paddingInline: "300",
          color: "text-core-default",
          children: node.label
        })
      }), /*#__PURE__*/_jsx("div", {
        children: hasChildren ? /*#__PURE__*/_jsx(IconButton, {
          onClick: () => setLocalOpen(prev => !prev),
          shape: "square",
          use: "secondary",
          children: localOpen ? /*#__PURE__*/_jsx(SidebarCollapseIcon, {
            size: "500"
          }) : /*#__PURE__*/_jsx(SidebarExpandIcon, {
            size: "500"
          })
        }) : /*#__PURE__*/_jsx("div", {
          style: {
            visibility: 'hidden'
          },
          children: /*#__PURE__*/_jsx(IconButton, {
            shape: "square",
            use: "secondary",
            children: /*#__PURE__*/_jsx(SidebarExpandIcon, {
              size: "500"
            })
          })
        })
      })]
    }), hasChildren && localOpen ? (_node$children = node.children) === null || _node$children === void 0 ? void 0 : _node$children.map((child, index) => /*#__PURE__*/_jsx(MenuNode, {
      node: child,
      depth: depth + 1,
      setOpen: setOpen
    }, `${node.label}-${child.label}-${index}`)) : null]
  });
};
export const MobileNavigationMenu = () => {
  const [open, setOpen] = useState(false);
  const menuChildren = useNavigationMenu();
  const {
    data
  } = usePortalData();
  const {
    settings
  } = data;
  const ticketListingsHeading = useMemo(() => {
    return settings.ticketLabelOverride || I18n.text('customer-portal-app.ticketListings.heading.default');
  }, [settings.ticketLabelOverride]);
  return /*#__PURE__*/_jsx(MobilePopover, {
    title: I18n.text('customer-portal-app.menuLabel'),
    open: open,
    onOpenChange: setOpen,
    content: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "300",
      padding: "800",
      children: [/*#__PURE__*/_jsx(RouterLink, {
        to: "/",
        onClick: () => setOpen(false),
        children: /*#__PURE__*/_jsx(Button, {
          use: "transparent",
          children: /*#__PURE__*/_jsx(Text, {
            color: "text-core-default",
            children: ticketListingsHeading
          })
        })
      }), menuChildren.map(node => /*#__PURE__*/_jsx(MenuNode, {
        node: node,
        depth: 0,
        setOpen: setOpen
      }, node.label))]
    }),
    footer: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "start",
      gap: "400",
      children: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Button, {
          use: "transparent",
          onClick: () => {
            window.location.href = LOGOUT_PATH;
          },
          children: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            gap: "200",
            children: [/*#__PURE__*/_jsx(LogoutIcon, {
              size: "500",
              color: "text-core-default"
            }), /*#__PURE__*/_jsx(Text, {
              color: "text-core-default",
              children: I18n.text('customer-portal-app.signOut')
            })]
          })
        })
      })
    }),
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Button, {
        use: "transparent",
        onClick: () => setOpen(o => !o),
        children: /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          gap: "200",
          children: /*#__PURE__*/_jsx(HamburgerMenuIcon, {
            color: "text-core-default"
          })
        })
      })
    })
  });
};